import React, { ReactNode } from 'react';
import { IconButton, CircularProgress } from '@mui/material';
import { useLoadingWithMinDuration } from '../../hooks/useLoadingWithMinDuration';
import { useSnackbar } from 'notistack';

interface DownloadButtonProps {
    onClick: () => Promise<void> | void;
    icon: ReactNode;
    title?: string;
    size?: 'small' | 'medium' | 'large';
    color?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    minLoadingDuration?: number;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
    onClick,
    icon,
    title,
    size = 'small',
    color = 'default',
    minLoadingDuration = 500
}) => {
    const { isLoading, execute } = useLoadingWithMinDuration(minLoadingDuration);
    const { enqueueSnackbar } = useSnackbar();

    const handleClick = () => {
        execute(async () => {
            try {
                await onClick();
            } catch (error: unknown) {
                console.error('Download failed:', error);
                enqueueSnackbar(
                    error instanceof Error ? error.message : 'Download fehlgeschlagen',
                    { variant: 'error' }
                );
            }
        });
    };

    const iconSize = size === 'small' ? 20 : size === 'large' ? 28 : 24;

    return (
        <IconButton
            size={size}
            color={color}
            onClick={handleClick}
            title={title}
            disabled={isLoading}
        >
            {isLoading ? (
                <CircularProgress size={iconSize} />
            ) : (
                icon
            )}
        </IconButton>
    );
};

export default DownloadButton;

